export const ModalSx = {
  width: '500px',
  height: 'auto',
  button: {
    fontWeight: 600,
  },
};
